import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { drContact, GetContactReq, GetContactResp, GetContactsGridReq, GetContactsGridResp, SetContactReq, ErrorResp, SetGeoLocationReq, GetFieldValuesReq, GetFieldValuesResp } from '@robisoft/cross-library';
import { DateTime } from 'luxon';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CrossContactsService {

  headers = new HttpHeaders({
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache, no-store, must-revalidate, post-check=0, pre-check=0',
    Pragma: 'no-cache'
  });
  constructor(private http: HttpClient) { }

  async getContact(endpoint: string, req: GetContactReq): Promise<GetContactResp | null> {
    let resp = null;
    try {
      resp = await lastValueFrom(this.http.post<GetContactResp>(endpoint + '/contacts/get_contact', req, { headers: this.headers }));
      if (!resp) {
        resp = new GetContactResp();
        resp.error = 'Non riesco a collegarmi al server (get_contact)';
        return resp;
      }

      if (!resp.error && resp.contact) {
        Object.setPrototypeOf(resp.contact, drContact.prototype);

        // aggiusto le date
        for (let i =0; i<12; i++) {
          if (resp.contact.D[i])
            resp.contact.D[i] = DateTime.fromISO(resp.contact.D[i]!.toString());
        }
        if (resp.contact.Birthday)
          resp.contact.Birthday = DateTime.fromISO(resp.contact.Birthday.toString());
        if (resp.contact.ExpiryDate)
          resp.contact.ExpiryDate = DateTime.fromISO(resp.contact.ExpiryDate.toString());
        if (resp.contact.LastAccess)
          resp.contact.LastAccess = DateTime.fromISO(resp.contact.LastAccess.toString());
        if (resp.contact.RegDate)
          resp.contact.RegDate = DateTime.fromISO(resp.contact.RegDate.toString());
        if (resp.contact.Created)
          resp.contact.Created = DateTime.fromISO(resp.contact.Created.toString());
        if (resp.contact.Modified)
          resp.contact.Modified = DateTime.fromISO(resp.contact.Modified.toString());
        if (resp.contact.Locked)
          resp.contact.Locked = DateTime.fromISO(resp.contact.Locked.toString());
        if (resp.contact.Deleted)
          resp.contact.Deleted = DateTime.fromISO(resp.contact.Deleted.toString());

      }

    } catch (err) {
      if (!resp) {
        resp = new GetContactResp();
        resp.error = 'Non riesco a collegarmi al server (get_contact) ' + err;
      }
    }

    return resp;
  }

  async getContacts(endpoint: string, req: GetContactsGridReq): Promise<GetContactsGridResp> {

    let resp = null;

    try {
      
      resp = await lastValueFrom(this.http.post<GetContactsGridResp>(endpoint + '/contacts/get_contacts_grid',
        req,
        { headers: this.headers }));

      if (!resp) {
        resp = new GetContactsGridResp();
        resp.error = 'Non riesco a collegarmi al server (get_contact)';
        return resp;
      }

      if (resp && resp.error === '') {

      }

    } catch (err) {
      if (!resp) {
        resp = new GetContactsGridResp();
        resp.error = 'Non riesco a collegarmi al server (get_contact) ' + err;
      }
    }

    return resp;
  }

  async setContact(endpoint: string, req: SetContactReq): Promise<ErrorResp> {

    let resp = null;
    try {
      resp = await lastValueFrom(this.http.post<ErrorResp>(endpoint + '/contacts/set_contact',
          JSON.stringify(req),
          {
              headers: this.headers
          }));

      if (!resp) {
        resp = new ErrorResp();
        resp.error = 'Non riesco a collegarmi al server (get_contact)';
        return resp;
      }
      
      if (resp && resp.error) {
          
      }

    } catch (err) {
      if (!resp) {
        resp = new ErrorResp();
      }
      resp.error = 'Non riesco a collegarmi al server (get_contact) ' + err;
      
    }

    return resp;
  }

  async setGeoLocation(endpoint: string, req: SetGeoLocationReq): Promise<ErrorResp> {

    let resp = null;
    try {
      resp = await lastValueFrom(this.http.post<ErrorResp>(endpoint + '/contacts/set_geolocation',
          JSON.stringify(req),
          {
              headers: this.headers
          }));

      if (!resp) {
        resp = new ErrorResp();
        resp.error = 'Non riesco a collegarmi al server (set_geolocation)';
        return resp;
      }
      
      if (resp && resp.error) {
          
      }

    } catch (err) {
      if (!resp) {
        resp = new ErrorResp();
      }
      resp.error = 'Non riesco a collegarmi al server (set_geolocation) ' + err;
      
    }

    return resp;
  }

  async getFieldValues(endpoint: string, req: GetFieldValuesReq): Promise<GetFieldValuesResp> {

    let resp = null;
    try {
      resp = await lastValueFrom(this.http.post<GetFieldValuesResp>(endpoint + '/contacts/get_field_values',
          JSON.stringify(req),
          {
              headers: this.headers
          }));

      if (!resp) {
        resp = new GetFieldValuesResp();
        resp.error = 'Non riesco a collegarmi al server (get_field_values)';
        return resp;
      }
      
      if (resp && resp.error) {
          
      }

    } catch (err) {
      if (!resp) {
        resp = new GetFieldValuesResp();
      }
      resp.error = 'Non riesco a collegarmi al server (get_field_values) ' + err;
      
    }

    return resp;
  }
  
}
